import React from 'react';
import { Col, Divider, Row } from 'antd';
import { useTranslation } from 'react-i18next';

const CustomTooltip = props => {
  const { t } = useTranslation();

  if (props && props.payload && props.payload[0] != null) {
    const newPayload = [
      ...props.payload,
      ...(props.hiddenSeries &&
        props.hiddenSeries
          .map(({ dataKey, index, color }) => {
            const value = props.payload[index].payload[dataKey];
            return value
              ? {
                  name: dataKey,
                  value,
                  color,
                }
              : null;
          })
          .filter(Boolean)),
    ];

    return (
      <div className="recharts-default-tooltip">
        <Row>
          {newPayload.map(record => (
            <>
              <Col className="chart-record-value justify-content-center" span={24} style={{ color: record.color }}>
                {props.valueFormatter(record.value)}
              </Col>
              <Col span={24} className="chart-record-name justify-content-center">
                {props.nameTranslation(record.name)}
              </Col>
            </>
          ))}
          <Divider style={{ margin: '4px 0' }} />
          <Col span={24} className="chart-record-label justify-content-center">{`(${props.labelFormatter(
            props.label
          )})`}</Col>
        </Row>
      </div>
    );
  }

  const mapLatestDataToSeries = (latestData, series) => {
    const date =
      latestData.dateFrom ?? latestData.date ?? latestData.month ?? latestData.yearQuarter ?? latestData.time;
    return series
      .map(({ dataKey, fill, stroke, color }) => {
        // Ensure dataKey exists in latestData
        if (dataKey in latestData) {
          return {
            date,
            value: latestData[dataKey],
            name: dataKey,
            color: fill ?? stroke ?? color,
          };
        }
        return null;
      })
      .filter(Boolean); // Remove nulls for unmatched keys
  };

  const latestValues = mapLatestDataToSeries(props.latestData, props.series);

  return (
    <div className="recharts-default-tooltip">
      <Row>
        {latestValues.map(record => (
          <>
            <Col className="chart-record-value justify-content-center" span={24} style={{ color: record.color }}>
              {props.valueFormatter(record.value)}
            </Col>
            <Col span={24} className="chart-record-name justify-content-center">
              {props.nameTranslation(record.name)}
            </Col>
          </>
        ))}
        <Divider style={{ margin: '4px 0' }} />
        <Col span={24} className="chart-record-label justify-content-center">{`(${props.labelFormatter(
          latestValues[0].date
        )})`}</Col>
      </Row>
    </div>
  );
};

export default CustomTooltip;
